export default __webpack_public_path__ + "static/supply-officer-b290cf0319bd5f6e04ce4321e0d8e5ed.jpg";